import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Observable } from 'rxjs';
import { ICalDTO, ICalWriteDTO } from '../interfaces/iCal';

@Injectable({
  providedIn: 'root'
})
export class ICalService {

  constructor(private dataService: DataService) { }

  saveICal(iCalId: number, iCal: ICalWriteDTO): Observable<ICalDTO> {
    if (iCalId && iCalId > 0) {
      return this.dataService.updateICal(iCalId, iCal);
    } else {
      return this.dataService.createICal(iCal);
    }
  }

  deleteICal(iCal: ICalDTO) {
    if (!iCal || iCal.id == null || iCal.id == undefined || iCal.id < 1) {
      return this.dataService.deleteICal(iCal.id);
    } else return null;
  }

  getICals(): Observable<any> {
    return this.dataService.getICals();
  }

  getICal(iCalId: number): Observable<any> {
    return this.dataService.getICal(iCalId);
  }

  testICalUrl(url: string) {
    return this.dataService.testICalUrl(url);
  }
}
